import { getToolsClient } from '@/services/tools'
import { getClient } from '@/services/identity'

const identityClient = getClient()
const toolsAxios = getToolsClient()
const baseEndpoint = '/custom-interval'

export const constants = {
  data: {
    deviceTypes: [],
    subscriptionTypes: [],
    intervals: [
      {
        "value" : "timer_10",
        "interval_name" : "10 Detik"
      },
      {
        "value" : "timer_30",
        "interval_name" : "30 Detik"
      },
      {
        "value" : "timer_60",
        "interval_name" : "60 Detik"
      },
    ],
  },
}

export const get = async (queryParam) => {
  queryParam.sorts = "created_at:desc"

  const params = {
    size: queryParam.size,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    q: queryParam?.q || undefined,
  }

  let response = await toolsAxios({
    method: 'GET',
    url: `${baseEndpoint}`,
    params: params,
  })

  response.data.data?.forEach((val) => {
    val['can_edit'] = true
    val['can_delete'] = true
    val['interval_name'] = constants.data.intervals.find((y) => y.value === val.interval).interval_name
  })

  response.data.total_count += 1

  await getRelations()

  return response?.data
}

export const show = async (id) => {
  const response = await toolsAxios({
    method: 'GET',
    url: `${baseEndpoint}/${id}`,
  })
  let result = response?.data
  result['can_edit'] = true
  result['can_delete'] = true
  result['interval_name'] = constants.data.intervals.find((y) => y.value === result.interval).interval_name

  return result
}

export const deleteSingle = async (id) => {
  let response
  try {
    const res = await toolsAxios({
      method: 'DELETE',
      url: `${baseEndpoint}/${id}`,
    })
    response = res
  } catch (error) {
    response = error?.response?.data
  }

  return response
}

export const deleteMany = async (ids) => {
  const _ids = ids.ids ?? ids
  const responses = await Promise.all(_ids?.map((id) => deleteSingle(id)))
  return responses.map((response) => response)
}

export const store = async (data) => {
  const response = await toolsAxios({
    method: 'POST',
    url: `${baseEndpoint}`,
    data: {
      device_codes : constants.data.deviceTypes.find(
        (deviceType) => deviceType.device_name === data.device_name
      ).device_code,
      interval : constants.data.intervals.find((y) => y.interval_name === data.interval_name).value,
      subscription_id : constants.data.subscriptionTypes.find(
        (subscriptionType) => subscriptionType.subscription === data.subscription
      ).uuid
    },
  })

  return response?.data
}

export const update = async (id, data) => {
  const response = await toolsAxios({
    method: 'PATCH',
    url: `${baseEndpoint}/${id}`,
    data: {
      device_codes : constants.data.deviceTypes.find(
        (deviceType) => deviceType.device_name === data.device_name
      ).device_code,
      interval : constants.data.intervals.find((y) => y.interval_name === data.interval_name).value,
      subscription_id : constants.data.subscriptionTypes.find(
        (subscriptionType) => subscriptionType.subscription === data.subscription
      ).uuid
    },
  })

  return response?.data
}

export const getRelations = async () => {
  const deviceTypes = await toolsAxios.get('/qcdevice/devicetypes')
  constants.data.deviceTypes = deviceTypes.data

  const subscription = await identityClient.get('api/subscription?page=1&limit=999999')
  constants.data.subscriptionTypes = subscription.data.data.pagination_result
}